import { WSTable } from "@wingspanhq/fe-component-library";
import { AccountTransaction } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { getColumns } from "./columns";

export type TableItemData = AccountTransaction;

type Props = {
  items: AccountTransaction[];
  loading?: boolean;
  onDispute?: (transaction: AccountTransaction) => void;
};

export const TableInternalAccountTransactions: React.FC<Props> = props => {
  const tableData = useMemo(
    () => props.items.map(item => ({ id: item.id, data: item })),
    [props.items]
  );

  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<TableItemData>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      rowMenuActions={
        props.onDispute
          ? item => [
              {
                label: "Dispute transaction",
                icon: "dispute",
                onClick: () => props.onDispute?.(item.data)
              }
            ]
          : undefined
      }
    />
  );
};
